module.exports = __webpack_public_path__ + "static/media/judgeCourtBanner.a8a79e6b.png";